import { Draft, PayloadAction } from "@reduxjs/toolkit";
import { CurriculumState } from "../../../curriculum-slice";
import { generateId } from "../../../../../components/new-editor/utils/nodeUtil";
import { duplicateWorkoutExercise } from "./operation";

export const duplicateWorkoutExerciseAction = {
  prepare(componentId: number, workoutSectionId: number, exerciseId: number) {
    return {
      payload: {
        componentId,
        workoutSectionId,
        exerciseId,
        newExerciseId: generateId(),
      },
    };
  },
  reducer(
    state: Draft<CurriculumState>,
    action: PayloadAction<{
      componentId: number;
      workoutSectionId: number;
      exerciseId: number;
      newExerciseId: number;
    }>,
  ) {
    const { componentId, workoutSectionId, exerciseId, newExerciseId } =
      action.payload;
    if (!componentId || !workoutSectionId || !exerciseId) return;

    const component = state.value.components[componentId];
    if (!component) return;

    const updatedContent = duplicateWorkoutExercise(
      workoutSectionId,
      exerciseId,
      newExerciseId,
      component.content,
    );

    state.value.components[componentId] = {
      ...component,
      content: updatedContent,
    };
  },
};
